namespace ExportProcessStateConstants {
  export const MAX_URI_LENGTH = 4096;
}

export default ExportProcessStateConstants;
